import { render, staticRenderFns } from "./ModalSolicitacaoAlteracaoDataAgendamentoClinica.vue?vue&type=template&id=b9730f96&scoped=true"
import script from "./ModalSolicitacaoAlteracaoDataAgendamentoClinica.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoAlteracaoDataAgendamentoClinica.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoAlteracaoDataAgendamentoClinica.vue?vue&type=style&index=0&id=b9730f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9730f96",
  null
  
)

export default component.exports